export const LOCALE_KEY = 'locale';
